import { MediaTranscoderGuard } from "../../guards/permission.guard";
import { MediaTranscoderComponent } from "./media-transcoder.component";
import { MediaTranscoderJobsComponent } from "./jobs/jobs.component";
import { MediaTranscoderJobsActiveComponent } from "./jobs/active/active.component";
import { MediaTranscoderHistoryComponent } from "./jobs/history/history.component";
import { MediaTranscoderJobEditorComponent } from "./jobs/job-editor/job-editor.component";
import { JobSettingsComponent } from "./jobs/job-settings/job-settings.component";
import { MediaTranscoderPackagerJobsComponent } from "./jobs/packager/packager.component";
import { PackagerSideEffectsGuard } from "./jobs/packager/packager-side-effects.guard";

export const MediaTranscoderRoutes = [
  {
    path: "media-transcoder",
    canActivate: [MediaTranscoderGuard],
    component: MediaTranscoderComponent,
    children: [
      {
        path: "jobs",
        component: MediaTranscoderJobsComponent,
        children: [
          {
            path: "active",
            component: MediaTranscoderJobsActiveComponent,
          },
          {
            path: "history",
            component: MediaTranscoderHistoryComponent,
          },
          {
            path: "packager",
            component: MediaTranscoderPackagerJobsComponent,
            canActivate: [PackagerSideEffectsGuard],
          },
          {
            path: "new",
            component: MediaTranscoderJobEditorComponent,
          },
          {
            path: "new/replicateFromId/:replicateFromId",
            component: MediaTranscoderJobEditorComponent,
          },
          {
            path: "edit/:id",
            component: MediaTranscoderJobEditorComponent,
          },
          { path: "**", redirectTo: "active" },
        ],
      },
      { path: "**", redirectTo: "jobs" },
    ],
  },
];
